import amerLogo from "../assets/AmerLogo.png";
import shadenLogo from "../assets/shadenLogo.jpeg";
import muniraLogo from "../assets/muniraLogo.jpeg";
import hasnaLogo from "../assets/hasnaLogo.jpeg";
import mohammedLogo from "../assets/mohammedLogo.jpeg";
export const APPLMembers = [
  {
    name: "Amer Alhelali",
    logo: amerLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/aamer-alhelaly",
    githubURL: "https://github.com/Aamer99",
    email: "aamer.alhelaly@gmail.com",
  },
  {
    name: "Shaden Aljaloud",
    logo: shadenLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/shaden-aljaloud-171592251",
    githubURL: "https://github.com/ShadenAl-jaloud",
    email: "shadenaljalood@gmail.com",
  },
  {
    name: "Munira Alhamdan",
    logo: muniraLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/munira-alhamdan",
    githubURL: "https://github.com/Munirabh",
    email: "Munira.b.hamdan@gmail.com",
  },
  {
    name: "Mohammed Alsaad",
    logo: mohammedLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/mohammed-alsaad-984abb239",
    githubURL: "https://github.com/Meem10",
    email: "Mohaalsaad.j@gmail.com",
  },
  {
    name: "Hasna Alsaqer",
    logo: hasnaLogo,
    description: "iOS developer, Software Engineer",
    linkedInURL: "https://linkedin.com/in/ha20s",
    githubURL: "https://github.com/ha20s",
    email: "hassna.ahmad98@gmail.com",
  },
];
